import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';

var FacebookLogin = /*#__PURE__*/function (_React$Component) {
  _inherits(FacebookLogin, _React$Component);

  var _super = _createSuper(FacebookLogin);

  function FacebookLogin() {
    var _this;

    _classCallCheck(this, FacebookLogin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "click", function () {
      var _this$props = _this.props,
          scope = _this$props.scope,
          appId = _this$props.appId;

      if (navigator.userAgent.match('CriOS')) {
        window.location.href = "https://www.facebook.com/dialog/oauth?client_id=".concat(appId) + "&redirect_uri=https://dev-api.postsocially.com&state=facebookdirect&".concat(scope);
      } else {
        window.FB.login(function (response) {
          if (response.authResponse) {
            _this.props.onLogin(null, response.authResponse);
          } else {
            _this.props.onLogin(response);
          }
        }, {
          scope: scope
        });
      }
    });

    return _this;
  }

  _createClass(FacebookLogin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          appId = _this$props2.appId,
          xfbml = _this$props2.xfbml,
          cookie = _this$props2.cookie,
          version = _this$props2.version,
          autoLoad = _this$props2.autoLoad,
          language = _this$props2.language;
      var fbRoot = document.getElementById('fb-root');

      if (!fbRoot) {
        fbRoot = document.createElement('div');
        fbRoot.id = 'fb-root';
        document.body.appendChild(fbRoot);
      }

      window.fbAsyncInit = function () {
        window.FB.init({
          version: "v".concat(version),
          appId: appId,
          xfbml: xfbml,
          cookie: cookie
        });

        if (autoLoad || window.location.search.includes('facebookdirect')) {
          window.FB.getLoginStatus(_this2.checkLoginState);
        }
      }; // Load the SDK asynchronously


      (function (d, id) {
        if (d.getElementById(id)) return;
        var js = d.createElement('script');
        js.id = id;
        js.src = "//connect.facebook.net/".concat(language, "/all.js");
        d.body.appendChild(js);
      })(document, 'facebook-jssdk');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          textButton = _this$props3.textButton,
          typeButton = _this$props3.typeButton,
          Component = _this$props3.component;
      if (Component) return /*#__PURE__*/React.createElement(Component, {
        facebookLogin: this.click
      });
      return /*#__PURE__*/React.createElement("button", {
        className: className,
        onClick: this.click,
        type: typeButton
      }, textButton);
    }
  }]);

  return FacebookLogin;
}(React.Component);

_defineProperty(FacebookLogin, "propTypes", {
  onLogin: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  xfbml: PropTypes.bool,
  cookie: PropTypes.bool,
  scope: PropTypes.string,
  autoLoad: PropTypes.bool,
  version: PropTypes.string,
  language: PropTypes.string,
  textButton: PropTypes.string,
  typeButton: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.func
});

_defineProperty(FacebookLogin, "defaultProps", {
  textButton: 'Login with Facebook',
  typeButton: 'button',
  className: '',
  scope: 'public_profile,email',
  xfbml: false,
  cookie: false,
  version: '2.3',
  language: 'en_US'
});

export default FacebookLogin;